import { useMediaQuery, useTheme } from '@mui/material'
import Dialog, { DialogProps } from '@mui/material/Dialog'

const useIsMobileBreakpoint = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return isMobile
}

type MobileFullScreenDialogProps = Omit<DialogProps, 'fullScreen'>

const MobileFullScreenDialog: React.FC<
  React.PropsWithChildren<MobileFullScreenDialogProps>
> = (props) => {
  const isMobile = useIsMobileBreakpoint()
  return (
    <Dialog fullScreen={isMobile} {...props}>
      {props.children}
    </Dialog>
  )
}

export default MobileFullScreenDialog
